/* eslint-disable max-len */
/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Inline warning feedback icon
 *
 * @file InlineWarningIcon.jsx
 * @author Gladson Samuel S
 * @since 2.0.0
 */

import React from 'react';
import { SvgIcon } from '@mui/material';

function InlineWarningIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 18 18">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18ZM8.25 5.25C8.25 4.83579 8.58579 4.5 9 4.5C9.41421 4.5 9.75 4.83579 9.75 5.25V9.75C9.75 10.1642 9.41421 10.5 9 10.5C8.58579 10.5 8.25 10.1642 8.25 9.75V5.25ZM9 13.125C9.62132 13.125 10.125 12.6213 10.125 12C10.125 11.3787 9.62132 10.875 9 10.875C8.37868 10.875 7.875 11.3787 7.875 12C7.875 12.6213 8.37868 13.125 9 13.125Z"
        fill="#B00020"
      />
    </SvgIcon>
  );
}

export default InlineWarningIcon;
